import React from "react";
import { Box, Typography } from "@mui/material";
import SVGSortAscending from "@/assets/icons/SVGSortAscending";
import SVGSortDescending from "@/assets/icons/SVGSortDescending";
import SVGSortUnsorted from "@/assets/icons/SVGSortUnsorted";

type SortDirection = "asc" | "desc" | null;

interface SortableTableHeaderProps {
  label: string;
  sortDirection: SortDirection;
  onSort: () => void;
  color?: string;
  size?: number;
}

const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  label,
  sortDirection,
  onSort,
  color = "#071D49",
  size = 16,
}) => {
  const getSortIcon = () => {
    switch (sortDirection) {
      case "asc":
        return <SVGSortAscending color={color} size={size} />;
      case "desc":
        return <SVGSortDescending color={color} size={size} />;
      default:
        return <SVGSortUnsorted color={color} size={size} />;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "4px",
        cursor: "pointer",
        userSelect: "none",
        "&:hover": {
          opacity: 0.8,
        },
      }}
      onClick={onSort}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: color,
          fontWeight: 400,
        }}
      >
        {label}
      </Typography>
      {getSortIcon()}
    </Box>
  );
};

export default SortableTableHeader;
